import React, { useEffect, useState } from "react";
import "./App.css";
import { useStore } from "./store";
import { Toast, BottomTabs } from "./components";
import { AuthScreen, HomeScreen, MapScreen, StakingScreen, ReferralScreen } from "./screens";
import { CardScreen, MarketplaceScreen, ExchangeScreen, P2PScreen, AIAgentScreen } from "./screens2";
import { WalletScreenV2, Magic44Screen } from "./screens3";
import { ProfileScreenV2 } from "./screens4";
import { ArrowLeft } from "lucide-react";

export default function MobileApp() {
  const { token, fetchAll, user } = useStore();
  const [tab, setTab] = useState("home");
  const [subScreen, setSubScreen] = useState(null);
  const [walletInitialTab, setWalletInitialTab] = useState("cash");
  const [booting, setBooting] = useState(true);

  useEffect(() => {
    (async () => {
      if (token) {
        try { await fetchAll(); } catch {}
      }
      setBooting(false);
    })();
  }, [token, fetchAll]);

  if (booting) {
    return (
      <div className="phone-frame">
        <div className="center-col" style={{ flex: 1 }}>
          <div style={{ fontSize: 40 }}>🚀</div>
          <div className="spinner" />
          <div className="text-muted">Загрузка TGC App...</div>
        </div>
      </div>
    );
  }

  if (!token || !user) {
    return (
      <div className="phone-frame">
        <Toast />
        <AuthScreen />
      </div>
    );
  }

  const handleNav = (screen) => {
    if (screen && screen.startsWith("wallet-")) {
      const sub = screen.split("-")[1];
      setWalletInitialTab(sub);
      setTab("wallet");
      setSubScreen(null);
      return;
    }
    const mainTabs = ["home", "map", "exchange", "wallet", "profile"];
    if (mainTabs.includes(screen)) {
      setTab(screen);
      setSubScreen(null);
    } else {
      setSubScreen(screen);
    }
  };

  const handleTab = (t) => {
    if (t === "wallet") setWalletInitialTab("cash");
    setTab(t);
    setSubScreen(null);
  };

  const handleBack = () => {
    if (subScreen) { setSubScreen(null); return; }
    if (tab !== "home") { setTab("home"); return; }
  };

  const showBack = subScreen !== null || tab !== "home";

  const renderScreen = () => {
    if (subScreen === "card")         return <CardScreen />;
    if (subScreen === "marketplace")  return <MarketplaceScreen />;
    if (subScreen === "ai")           return <AIAgentScreen />;
    if (subScreen === "p2p")          return <P2PScreen />;
    if (subScreen === "staking")      return <StakingScreen />;
    if (subScreen === "referral")     return <ReferralScreen />;
    if (subScreen === "magic44")      return <Magic44Screen />;
    if (subScreen === "scanner")      return <MapScreen />;
    if (subScreen === "exchange-full")return <ExchangeScreen />;

    switch (tab) {
      case "home":     return <HomeScreen onNav={handleNav} />;
      case "map":      return <MapScreen />;
      case "exchange": return <ExchangeScreen />;
      case "wallet":   return <WalletScreenV2 initialTab={walletInitialTab} />;
      case "profile":  return <ProfileScreenV2 onNav={handleNav} />;
      default:         return <HomeScreen onNav={handleNav} />;
    }
  };

  return (
    <div className="phone-frame">
      <Toast />
      {showBack && (
        <button onClick={handleBack}
          style={{
            position: "absolute", top: 16, left: 12, zIndex: 50,
            width: 36, height: 36, borderRadius: 18,
            background: "rgba(255,255,255,0.2)", border: "none",
            display: "flex", alignItems: "center", justifyContent: "center",
            color: "white", cursor: "pointer", backdropFilter: "blur(10px)"
          }}
          data-testid="back-btn"
          aria-label="Назад"
        >
          <ArrowLeft size={18} />
        </button>
      )}
      {renderScreen()}
      <BottomTabs active={tab} onChange={handleTab} />
    </div>
  );
}
